import React from 'react';
import { Box, Skeleton, SkeletonText, Flex } from '@chakra-ui/react';

const ProductCardSkeleton = () => {
  return (
    <Box
      borderRadius="lg"
      overflow="hidden"
      bg="white"
      boxShadow="md"
      display="flex"
      flexDirection="column"
    >
      <Skeleton height="200px" />
      <Box p={4} flex="1">
        <SkeletonText noOfLines={2} spacing="4" />
        <Flex justify="space-between" align="center" mt={4}>
          <Skeleton height="20px" width="80px" />
          <Skeleton height="30px" width="100px" />
        </Flex>
      </Box>
    </Box>
  );
};

export default ProductCardSkeleton;
